"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _omitProps = _interopRequireDefault(require("../../../../omitProps"));
var _TextInput = _interopRequireDefault(require("../../../TextInput"));
var _withLogic = _interopRequireDefault(require("../withLogic"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = (0, _withLogic["default"])((0, _omitProps["default"])(_TextInput["default"], ['form']));
exports["default"] = _default;